import { getConfig, MAILTO } from '../config';
import { DeployArea } from '../model';
import { interceptNumberOfChar } from './string';

export const formatEmailName = (email?: string) => {
  if (email) {
    const arr = email.split('@');
    return arr[0];
  }
  return '';
};

export const getEmailFirstChar = (str?: string) => {
  return interceptNumberOfChar(formatEmailName(str));
};

export const openContactMethod = (event?: { preventDefault: () => void }) => {
  event?.preventDefault();
  const deployArea: DeployArea = getConfig()?.deployArea;
  const isWoa = deployArea === DeployArea.woa;

  if (isWoa) {
    const { woaContactPerson } = getConfig();
    if (woaContactPerson) {
      window.open(`wxwork://message?username=${woaContactPerson}`, '_blank');
    }
  } else {
    window.location.href = `mailto:${MAILTO}`;
  }
};
